// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box } from '@iheartjane/reefer';

export const AgeGateFormContainer = styled(Box)({
  padding: '40px',
  border: 'none',
  borderRadius: '24px',
  boxShadow: `0px 2px 16px 0px rgba(0, 0, 0, 0.05),
    0px 0px 0px 1px rgba(0, 0, 0, 0.05)`,
  marginTop: '24px',
});
